// @flow
const RTI_STATUS = 'admin/rti/RTI_STATUS';
const RTI_STATUS_FAIL = 'admin/rti/RTI_STATUS_FAIL';
const RTI_STATUS_SUCCESS = 'admin/rti/RTI_STATUS_SUCCESS';

const RTI_TOGGLE = 'admin/rti/RTI_TOGGLE';
const RTI_TOGGLE_FAIL = 'admin/rti/RTI_TOGGLE_FAIL';
const RTI_TOGGLE_SUCCESS = 'admin/rti/RTI_TOGGLE_SUCCESS';

export {
  RTI_STATUS,
  RTI_STATUS_SUCCESS,
  RTI_STATUS_FAIL,
  RTI_TOGGLE,
  RTI_TOGGLE_SUCCESS,
  RTI_TOGGLE_FAIL,
};

export type RTI = {
  rtiEnabled: boolean,
};

type RTIStatusAction = {|
  type: 'admin/rti/RTI_STATUS',
|};

type RTIStatusFailAction = {|
  type: 'admin/rti/RTI_STATUS_FAIL',
|};

type RTIStatusSuccessAction = {|
  type: 'admin/rti/RTI_STATUS_SUCCESS',
  payload: {|
    +isEnabled: boolean,
  |},
|};

type RTIToggleAction = {|
  type: 'admin/rti/RTI_TOGGLE',
|};

type RTIToggleFailAction = {|
  type: 'admin/rti/RTI_TOGGLE_FAIL',
|};

type RTIToggleSuccessAction = {|
  type: 'admin/rti/RTI_TOGGLE_SUCCESS',
|};

export type Action =
  | RTIStatusAction
  | RTIStatusSuccessAction
  | RTIStatusFailAction
  | RTIToggleAction
  | RTIToggleSuccessAction
  | RTIToggleFailAction;



// WEBPACK FOOTER //
// ./src/state/types/rtiTypes.js